import { observer } from 'mobx-react-lite'
import { useMainContainerStore } from '../MainContainerStore'
import ExtendedMenu from './ExtendedMenu'
import ReducedMenu from './ReducedMenu'
import useWindowSize from 'reusable/hooks/useWindowSize'

export default observer(function NavigationMenu() {
   const mainContainerStore = useMainContainerStore()
   const windowSize = useWindowSize()

   if (windowSize.screenLayout === 'tablet') {
      // Tablet will always display the reducedmenu, with the extended menu over it as a drawer
      return <ReducedMenu />
   } else if (windowSize.screenLayout === 'mobile') {
      // Mobile does not have the menu on the left, it just has a drawer
      return null
   }

   // If the menu has no items. This would occurr for a deactivated user. Make sure the user has loaded in for this
   if (!mainContainerStore.sp.routerStore.menu.length && !mainContainerStore.sp.orgGuardStore.loading) {
      return null
   }

   if (mainContainerStore.menuState.visible) {
      return <ExtendedMenu />
   } else {
      return <ReducedMenu />
   }
})
